import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import {
  forwardRef,
  Directive,
  Renderer2,
  ElementRef,
  Input
} from '@angular/core';
import { fromEvent, merge, timer } from 'rxjs';
import { map, debounce } from 'rxjs/operators';

export const DEFAULT_VALUE_ACCESSOR: any = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => NgModelOptionsDirective),
  multi: true
};

@Directive({
  selector:
    '[formControlName][ngModelOptions],[formControl][ngModelOptions],[ngModel][ngModelOptions]',
  providers: [DEFAULT_VALUE_ACCESSOR]
})
export class NgModelOptionsDirective implements ControlValueAccessor {
  private _controlOptions = {
    updateOn: 'input',
    debounce: null
  };
  @Input()
  set ngModelOptions(val) {
    this._controlOptions = { ...this._controlOptions, ...val };
  }
  onChange;
  onTouched;

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  constructor(private renderer: Renderer2, private element: ElementRef) {}

  events;
  ngOnInit() {
    const events = this._controlOptions.updateOn
      .split(' ') // ['input', 'blur']
      .map(event => fromEvent(this.element.nativeElement, event));

    this.events = merge(...events) // spread the events
      .pipe(
        map((event: Event) => {
          return { type: event.type, value: event.target['value'] };
        }),
        debounce(event => {
          const debounceValue = this._controlOptions.debounce;
          let time = 0;
          if (typeof debounceValue === 'number') {
            time = debounceValue;
          } else if (typeof debounceValue === 'object') {
            time = debounceValue[event.type] ? debounceValue[event.type] : 0;
          }
          return timer(time);
        })
      )
      .subscribe(event => {
        this.onChange(event.value);
      });
  }

  writeValue(value: any): void {
    const normalizedValue = value == null ? '' : value;
    this.renderer.setProperty(
      this.element.nativeElement,
      'value',
      normalizedValue
    );
  }

  setDisabledState(isDisabled: boolean): void {
    this.renderer.setProperty(
      this.element.nativeElement,
      'disabled',
      isDisabled
    );
  }
}
